import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate } from "react-router-dom"
import Modal from './Modal'
import Button from '../formfields/Button'
import { subscribe } from "../utils/pubsub"
import Spinner from './Spinner'



type Props = {
  handleLogout: AnyFunction
}

type LoggedInProps = {
  userData: ObjectStringKeyAnyValue | null
  tableData: ObjectStringKeyAnyValue | null
  handleLogout: () => void
  currentPortalId: string | null,
  switchCurrentPortalId: (organisationId: string) => void
  setShowModal: React.Dispatch<React.SetStateAction<any>>,
  unsortedOrganisations: ObjectStringKeyAnyValue | null
  sortedOrganisationIds: Array<string> | null
  sendMessageToWebsocket: (payload: string) => void
  savingProgress: boolean
  setSavingProgress: React.Dispatch<React.SetStateAction<any>>
}

type MenuProps = {
  unsortedOrganisations: ObjectStringKeyAnyValue | null
  sortedOrganisationIds: Array<string> | null
  tableData: ObjectStringKeyAnyValue | null
  setShowMenu: React.Dispatch<React.SetStateAction<any>>,
  currentPortalId: string | null,
  userData: ObjectStringKeyAnyValue | null
  setShowOrgsMenu: React.Dispatch<React.SetStateAction<any>>,
  showOrgsMenu: boolean
  switchCurrentPortalId: (organisationId: string) => void
  numberOfOrganisationsForThisUser: number,
  handleLogout: () => void
  sendMessageToWebsocket: (payload: string) => void
  savingProgress: boolean
  setSavingProgress: React.Dispatch<React.SetStateAction<any>>
}





function Menu({
  tableData,
  unsortedOrganisations,
  sortedOrganisationIds,
  setShowMenu,
  currentPortalId,
  userData,
  setShowOrgsMenu,
  showOrgsMenu,
  switchCurrentPortalId,
  numberOfOrganisationsForThisUser,
  handleLogout,
  sendMessageToWebsocket,
  savingProgress,
  setSavingProgress
}: MenuProps) {


  const navigate = useNavigate()
  // organisations sorted alphabetically


  const currentPortalName = tableData && currentPortalId && tableData.Portals && tableData.Portals[currentPortalId] ? tableData.Portals[currentPortalId].DisplayName : 'No portal selected'




  return <div className={`fixed top-0 left-0 w-full flex flex-col items-center`}>


    <div className={`max-w-3xl px-4 w-full flex flex-col items-end`}>
      <div
        style={{
          width: '260px',
          top: '65px'
        }}
        className={`bg-brandblue fixed p-2 rounded flex flex-col gap-1 text-white text-xs z-50`}
        onMouseLeave={() => setShowMenu(false)}
      >



        <div className={`md:hidden flex flex-col pb-2 gap-1`}>
          <div className={`flex flex-row gap-2 items-center`}>
            <img src='/icons/usericon.svg' className={`w-5`} alt='' />
            <p className={`font-bold`}>{userData!.name}</p>
          </div>
          {currentPortalName && <p className={``}>{currentPortalName}</p>}
        </div>


        {tableData && tableData.Portals && Object.keys(tableData.Portals).length > 1 && <>
          <div
            className={`font-bold text-sm px-3 py-2 rounded hover:opacity-90 bg-brandmidblue`}
          >

            <div className={`flex flex-row items-center gap-2`} onClick={() => setShowOrgsMenu(!showOrgsMenu)}>
              <p className={`font-righteous text-lg`}>Select portal:</p>
              <img src='/arrow.svg' alt='' className={`h-3 ${showOrgsMenu && 'rotate-90'}`} />
            </div>



              <div
              className={`pt-2 text-left overflow-y-auto`}
              style={{ maxHeight: '30vh' }}
              >
                {
                  Object.keys(tableData.Portals).map((portalId, index) => {
                    return <div
                      className={`${currentPortalId === portalId ? ' font-bold ' :  ' font-normal underline '}  py-1 `}
                      key={index}
                      onClick={() => {
                        setShowMenu(false)
                        switchCurrentPortalId(portalId)
                      }}>
                      {tableData.Portals[portalId].DisplayName}
                    </div>
                  })
                }
              </div>
          </div>
        </>}


        <Button
          internalLinkUrl='/users'
          text='Users'
          variant={`secondary`}
          align={'left'}
        />
        <Button
          internalLinkUrl='/automatic-reports'
          text='Automatic Reports'
          variant={`secondary`}
          align={'left'}
        />

        <Button
          onClick={handleLogout}
          text='Log out'
          variant={`secondary`}
          align={'left'}
        />


      </div>
    </div>



  </div>
}



function LoggedIn({
  tableData,
  userData,
  handleLogout,
  currentPortalId,
  switchCurrentPortalId,
  setShowModal,
  unsortedOrganisations,
  sortedOrganisationIds,
  sendMessageToWebsocket,
  savingProgress,
  setSavingProgress
}: LoggedInProps) {

  const [showMenu, setShowMenu] = useState(false)
  const [showOrgsMenu, setShowOrgsMenu] = useState(false)
  const numberOfOrganisationsForThisUser = sortedOrganisationIds ? Object.keys(sortedOrganisationIds).length : 0

  const currentPortalName = tableData && currentPortalId && tableData.Portals && tableData.Portals[currentPortalId] ? tableData.Portals[currentPortalId].DisplayName : 'No portal selected'




  return <div className={`flex flex-row items-center gap-4`}>



    {showMenu && <Menu
unsortedOrganisations={unsortedOrganisations}
sortedOrganisationIds={sortedOrganisationIds}
      setShowMenu={setShowMenu}
      currentPortalId={currentPortalId}
      userData={userData}
      setShowOrgsMenu={setShowOrgsMenu}
      showOrgsMenu={showOrgsMenu}
      switchCurrentPortalId={switchCurrentPortalId}
      numberOfOrganisationsForThisUser={numberOfOrganisationsForThisUser}
      handleLogout={handleLogout}
      sendMessageToWebsocket={sendMessageToWebsocket}
      tableData={tableData}
      savingProgress={savingProgress}
      setSavingProgress={setSavingProgress}
    />
    }

    <div className={`text-white hidden md:flex flex-col items-start justify-between gap-2 text-xs`}>
      <div className={` flex flex-row items-center gap-2`}>
        <img src='/icons/usericon.svg' className={`w-6`} alt='' />
        <p>{userData!.name}</p>
      </div>

      {currentPortalName && <p className={``}>{currentPortalName}</p>}

    </div>


    <div className={`block w-11 p-2 bg-brandblue`}>
      {showMenu ?
        <img
          src='/icons/close-x.svg'
          alt='Menu'
          className={`w-full cursor-pointer`}
          onClick={() => setShowMenu(false)} /> :
        <img
          src='/icons/hamburger.svg'
          alt='Menu'
          className={`w-full cursor-pointer`}
          onClick={() => setShowMenu(true)} />
      }
    </div>



  </div >
}

function Header({
  handleLogout
}: Props) {




  const {
    tableData,
    userData,
    currentPortalId,
    switchCurrentPortalId,
    sendMessageToWebsocket,
    loggedIn
  } = useContext(GlobalContext)


  const [savingProgress, setSavingProgress] = useState(false)
  const unsortedOrganisations = userData ? JSON.parse(userData.organisationsForUser) : {}
  const sortedOrganisationIds = unsortedOrganisations && Object.entries(unsortedOrganisations)
  .sort((a: any, b: any) => a[1].trim().localeCompare(b[1].trim()))
  .map(entry => entry[0])

  const navigate = useNavigate()
  const [showSwitchOrg, setShowModal] = useState(false)




  return <header
    className={`w-full z-50 flex flex-col items-center bg-brandblue`}
    style={{ background: `linear-gradient(rgba(22, 28, 46}, 0.8), rgba(22, 28, 46, 0.8)), url(/jessica-lewis-fJXv46LT7Xk-unsplash.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }}
  >

    <div className={`max-w-3xl w-full p-4 flex flex-row items-center justify-between gap-5`}>
      <Link to={'/'}>
        <img
          src={`/logos/logo-white-no-strapline.svg`}
          alt='ChecQR Logo'
          className={`border-0`}
          style={{
            width: '100%',
            maxWidth: '200px',
            maxHeight: '70px'
           }}
        />
      </Link>

      {loggedIn === true && userData &&
        <LoggedIn
          userData={userData}
          handleLogout={handleLogout}
          currentPortalId={currentPortalId}
          switchCurrentPortalId={switchCurrentPortalId}
          setShowModal={setShowModal}
          unsortedOrganisations={unsortedOrganisations}
          sortedOrganisationIds={sortedOrganisationIds}
          sendMessageToWebsocket={sendMessageToWebsocket}
          tableData={tableData}
          savingProgress={savingProgress}
          setSavingProgress={setSavingProgress}
        />
      }

    </div>

    {savingProgress && <Modal
      showCloseButton={true}
      setShowModal={setSavingProgress}
    ><Spinner><p>Clearing demo data...</p></Spinner>
    </Modal>}

  </header>
}
export default Header